var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eb-page',[_c('eb-navbar',{attrs:{"title":_vm.$text('Default'),"eb-back-link":"Back"}}),_vm._v(" "),(_vm.ready)?_c('eb-json-editor',{ref:"jsonEditor",attrs:{"readOnly":true,"valueType":"object","value":_vm.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }